/*jshint esversion: 8 */

import { useQuery } from 'react-query';
import TabbedProjectComponent from "./TabbedProjectComponent";
import { fetchProjects } from '../../../utils/api';
import Loading from '../../../shared/Loading/Loading';

const AllProject = () => {
  const { data, error, isLoading } = useQuery('projects', fetchProjects);

  if (isLoading) {
    return <Loading/>
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div>
      {/* Render your components here */}
      <TabbedProjectComponent data={data} />
    </div>
  );
};

export default AllProject;